import { render, staticRenderFns } from "./SenderForm.vue?vue&type=template&id=cded9e14&"
import script from "./SenderForm.vue?vue&type=script&lang=js&"
export * from "./SenderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports